import Image from 'next/image';

import { formatNumber, TransformedDapp } from '@/utils';

export const RewardTokens = ({ tokens }: { tokens: TransformedDapp['rewardTokens'] }) => (
  <div className="w-full flex gap-4">
    {tokens.map((token, index) => (
      <div
        key={`${token.name}-${index}`}
        className="w-full flex flex-col gap-3 items-center justify-center bg-neutral-1000 px-8 py-6 rounded-xl"
      >
        <div className="flex gap-2">
          {token.image && <Image src={token.image} width={14} height={14} alt={`token icon`} />}
          <p className="font-mono font-semibold text-sm text-grey-100 uppercase">{token.name}</p>
        </div>
        <p className="font-chakra font-bold text-2xl text-neutral-100">{formatNumber(Number(token.amount))}</p>
      </div>
    ))}
  </div>
);
